export default function Pricing() {
  const plans = [
    {
      name: 'Basic',
      price: 99,
      popular: false,
      features: [
        { text: 'Bi-weekly lawn mowing', included: true, link: 'https://www.instagram.com/reel/C6BitbZONTN/?igsh=MWN2NncweDh6OG4wOA==' },
        { text: 'Edge trimming', included: true, link: 'https://www.instagram.com/reel/C69StF-u0jj/?igsh=NGMzdW45ZGt4ZHZr' },
        { text: 'Organic fertilizer (2x/year)', included: true },
        { text: 'Fall leaves pick up', included: true, link: 'https://www.instagram.com/reel/C_k3-zgOFGa/?igsh=b3h4b2V4cXBwcmF6' },
        { text: 'Snow removal (4+ inches)', included: true, link: 'https://www.instagram.com/reel/DTbi6jejFJE/?igsh=MXh2d2w1bW5mNms4eg==' },
        { text: 'Weed control', included: false, link: 'https://www.instagram.com/reel/C6dtisdukyG/?igsh=MXgxZ3NvODQ2aGpiNw==' },
        { text: 'Tree and shrub maintenance', included: false, link: 'https://www.instagram.com/reel/C7RGGAJOHKu/?igsh=MW9hdWpscXZveXoxag==' },
        { text: 'Gardening', included: false, link: 'https://www.instagram.com/reel/C6lvOdTuIaH/?igsh=MTJya213cmd4cTJmMg==' },
        { text: 'Spring clean up', included: false, link: 'https://www.instagram.com/reel/C6Hr76EuVLE/?igsh=aGd6czgwemhiMXg3' },
        { text: '24/7 emergency service', included: false },
      ],
    },
    {
      name: 'Complete',
      price: 169,
      popular: true,
      features: [
        { text: 'Lawn mowing (3x/month)', included: true, link: 'https://www.instagram.com/reel/C6BitbZONTN/?igsh=MWN2NncweDh6OG4wOA==' },
        { text: 'Edge trimming', included: true, link: 'https://www.instagram.com/reel/C69StF-u0jj/?igsh=NGMzdW45ZGt4ZHZr' },
        { text: 'Organic fertilizer (2x/year)', included: true },
        { text: 'Fall leaves pick up', included: true, link: 'https://www.instagram.com/reel/C_k3-zgOFGa/?igsh=b3h4b2V4cXBwcmF6' },
        { text: 'Snow removal (2+ inches)', included: true, link: 'https://www.instagram.com/reel/DTbi6jejFJE/?igsh=MXh2d2w1bW5mNms4eg==' },
        { text: 'Tree & shrub trimming', included: true },
        { text: 'Spring clean up', included: true, link: 'https://www.instagram.com/reel/C6Hr76EuVLE/?igsh=aGd6czgwemhiMXg3' },
        { text: 'Free garden design consultation', included: true, link: 'https://www.instagram.com/reel/C6lvOdTuIaH/?igsh=MTJya213cmd4cTJmMg==' },
        { text: 'Weed control', included: false, link: 'https://www.instagram.com/reel/C6dtisdukyG/?igsh=MXgxZ3NvODQ2aGpiNw==' },
        { text: 'Gardening', included: false, link: 'https://www.instagram.com/reel/C6lvOdTuIaH/?igsh=MTJya213cmd4cTJmMg==' },
        { text: 'Tree and shrub maintenance', included: false, link: 'https://www.instagram.com/reel/C7RGGAJOHKu/?igsh=MW9hdWpscXZveXoxag==' },
      ],
    },
    {
      name: 'Premium',
      price: 299,
      popular: false,
      features: [
        { text: 'Weekly lawn mowing', included: true, link: 'https://www.instagram.com/reel/C6BitbZONTN/?igsh=MWN2NncweDh6OG4wOA==' },
        { text: 'Edge trimming', included: true, link: 'https://www.instagram.com/reel/C69StF-u0jj/?igsh=NGMzdW45ZGt4ZHZr' },
        { text: 'Organic fertilizer (3x/year)', included: true },
        { text: 'Garden maintenance', included: true, link: 'https://www.instagram.com/reel/C7jnua5umTR/?igsh=MWpuenZ4Z3I4cWw0NA==' },
        { text: 'Weed control program', included: true, link: 'https://www.instagram.com/reel/C6dtisdukyG/?igsh=MXgxZ3NvODQ2aGpiNw==' },
        { text: 'Tree and shrub maintenance', included: true, link: 'https://www.instagram.com/reel/C5sz49nu9gk/?igsh=ZWx3bmYyM3NvMGF4' },
        { text: 'Fall leaves pick up', included: true, link: 'https://www.instagram.com/reel/C_k3-zgOFGa/?igsh=b3h4b2V4cXBwcmF6' },
        { text: 'Snow removal (2+ inches) + salting', included: true, link: 'https://www.instagram.com/reel/DTbi6jejFJE/?igsh=MXh2d2w1bW5mNms4eg==' },
        { text: 'Spring clean up', included: true, link: 'https://www.instagram.com/reel/C6Hr76EuVLE/?igsh=aGd6czgwemhiMXg3' },
        { text: 'Free garden design & renderings', included: true, link: 'https://www.instagram.com/reel/C6lvOdTuIaH/?igsh=MTJya213cmd4cTJmMg==' },
      ],
    },
    {
      name: 'Commercial & Large Estates',
      price: null,
      popular: false,
      isCommercial: true,
      features: [
        { text: 'Lawn mowing & edging', included: true, link: 'https://www.instagram.com/reel/C6BitbZONTN/?igsh=MWN2NncweDh6OG4wOA==' },
        { text: 'Fertilizing & weed control', included: true, link: 'https://www.instagram.com/reel/C6dtisdukyG/?igsh=MXgxZ3NvODQ2aGpiNw==' },
        { text: 'Mulching & planting', included: true, link: 'https://www.instagram.com/reel/DOoZ6KwjtMW/?igsh=MWE3bzZ3d3l1am01Zw==' },
        { text: 'Tree & shrub care', included: true, link: 'https://www.instagram.com/reel/C5sz49nu9gk/?igsh=ZWx3bmYyM3NvMGF4' },
        { text: 'Garden design & construction', included: true, link: 'https://www.instagram.com/reel/C6lvOdTuIaH/?igsh=MTJya213cmd4cTJmMg==' },
        { text: 'Hardscaping & patios', included: true, link: 'https://www.instagram.com/reel/C5-t0dmOzPr/?igsh=MXg3MzZuNHIwd28weg==' },
        { text: 'Retaining walls', included: true, link: 'https://www.instagram.com/reel/C6V9zGBu3n0/?igsh=amM4NjJ2Zml4OGtr' },
        { text: 'Irrigation systems', included: true },
        { text: 'Snow removal (1+ inch trigger)', included: true, link: 'https://www.instagram.com/reel/DTbi6jejFJE/?igsh=MXh2d2w1bW5mNms4eg==' },
        { text: 'Pre-salting (1+ inch trigger)', included: true },
        { text: 'Spring & fall cleanup', included: true, link: 'https://www.instagram.com/reel/C6Hr76EuVLE/?igsh=aGd6czgwemhiMXg3' },
        { text: '24/7 emergency service', included: true },
      ],
    },
  ];

  return (
    <section id="pricing" className="py-20 bg-gradient-to-b from-gray-900 to-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-yellow-400 text-gray-900 rounded-full text-sm font-semibold mb-4">
            Simple Pricing
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">One Simple Monthly Price</h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Choose the plan that fits your property needs. All plans include both landscaping and snow removal.
          </p>
        </div>

        {/* Pricing Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {plans.map((plan, idx) => (
            <div
              key={idx}
              className={`relative rounded-2xl overflow-hidden transform transition-all duration-300 ${
                plan.popular
                  ? 'bg-gradient-to-br from-yellow-400 to-yellow-500 scale-105 shadow-2xl'
                  : plan.isCommercial
                  ? 'bg-gradient-to-br from-yellow-400 to-yellow-500 hover:shadow-xl hover:-translate-y-1'
                  : 'bg-white hover:shadow-xl hover:-translate-y-1'
              }`}
            >
              {plan.popular && (
                <div className="absolute top-0 right-0 bg-cyan-400 text-gray-900 px-4 py-1 text-sm font-bold rounded-bl-lg">
                  MOST POPULAR
                </div>
              )}

              <div className="p-8">
                {/* Plan Header */}
                <h3
                  className={`text-2xl font-bold mb-2 ${plan.popular || plan.isCommercial ? 'text-gray-900' : 'text-gray-900'}`}
                >
                  {plan.name}
                </h3>
                <div className="mb-6">
                  {plan.isCommercial ? (
                    <>
                      <div className={`text-sm font-semibold mb-1 text-gray-700`}>
                        Custom Pricing
                      </div>
                      <span className={`text-3xl font-bold text-gray-900`}>
                        Contact Us
                      </span>
                    </>
                  ) : (
                    <>
                      <div className={`text-sm font-semibold mb-1 ${plan.popular ? 'text-gray-700' : 'text-gray-600'}`}>
                        Starting at
                      </div>
                      <span className={`text-5xl font-bold ${plan.popular ? 'text-gray-900' : 'text-gray-900'}`}>
                        ${plan.price}
                      </span>
                      <span className={`text-lg ${plan.popular ? 'text-gray-700' : 'text-gray-500'}`}>
                        /month
                      </span>
                    </>
                  )}
                </div>

                {/* Features Table */}
                <div className="mb-8">
                  {/* Table Header */}
                  <div className="flex items-center mb-3 pb-2 border-b border-gray-300">
                    <div className="flex-1">
                      <span className={`text-xs font-bold uppercase ${plan.popular || plan.isCommercial ? 'text-gray-700' : 'text-gray-600'}`}>
                        Services
                      </span>
                    </div>
                    <div className="w-20 text-center">
                      <span className={`text-xs font-bold uppercase ${plan.popular || plan.isCommercial ? 'text-gray-700' : 'text-gray-600'}`}>
                        Our Work
                      </span>
                    </div>
                  </div>

                  {/* Features List */}
                  <ul className="space-y-3">
                    {plan.features.map((feature, featureIdx) => (
                      <li key={featureIdx} className="flex items-center">
                        <div className={`w-6 h-6 flex items-center justify-center rounded-full flex-shrink-0 mr-3 ${
                          feature.included
                            ? plan.popular || plan.isCommercial
                              ? 'bg-gray-900/20'
                              : 'bg-green-100'
                            : 'bg-gray-200'
                        }`}>
                          <i
                            className={`text-sm ${
                              feature.included
                                ? plan.popular || plan.isCommercial
                                  ? 'ri-check-line text-gray-900'
                                  : 'ri-check-line text-green-600'
                                : 'ri-close-line text-gray-400'
                            }`}
                          ></i>
                        </div>
                        <span
                          className={`text-sm flex-1 ${
                            feature.included
                              ? plan.popular || plan.isCommercial
                                ? 'text-gray-900'
                                : 'text-gray-700'
                              : plan.popular || plan.isCommercial
                              ? 'text-gray-600'
                              : 'text-gray-400'
                          }`}
                        >
                          {feature.text}
                        </span>
                        <div className="w-20 flex items-center justify-center">
                          {feature.link && feature.included && (
                            <a
                              href={feature.link}
                              target="_blank"
                              rel="noopener noreferrer"
                              className={`w-8 h-8 flex items-center justify-center rounded-lg transition-all hover:scale-110 cursor-pointer ${
                                plan.popular || plan.isCommercial
                                  ? 'bg-gray-900/20 hover:bg-gray-900/30' 
                                  : 'bg-pink-50 hover:bg-pink-100'
                              }`}
                            >
                              <i className={`ri-instagram-line text-lg ${
                                plan.popular || plan.isCommercial ? 'text-gray-900' : 'text-pink-600'
                              }`}></i>
                            </a>
                          )}
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* CTA Button */}
                <button
                  onClick={() => {
                    const element = document.getElementById('contact');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className={`w-full py-3 rounded-lg font-bold transition-all whitespace-nowrap cursor-pointer ${
                    plan.popular || plan.isCommercial
                      ? 'bg-gray-900 text-white hover:bg-gray-800'
                      : 'bg-gradient-to-r from-yellow-400 to-yellow-500 text-gray-900 hover:from-yellow-500 hover:to-yellow-600'
                  }`}
                >
                  {plan.isCommercial ? 'Contact Us' : 'Get Started'}
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Note */}
        <div className="text-center">
          <p className="text-gray-300 text-lg">
            <i className="ri-information-line mr-2"></i>
            Custom quotes available based on your property size and specific needs
          </p>
        </div>
      </div>
    </section>
  );
}
